import { parseISO, isToday, format, isYesterday } from "date-fns";
import { CallTaskActionType } from "../../call-management.types.js";
const getUnsuccessfullCallbackTime = (action) => {
  if (!action || action.type !== CallTaskActionType.UnsuccessfulCallBack)
    return null;
  return action == null ? void 0 : action.timeStamp;
};
const formatEventTime = (eventTime, labels) => {
  const time = parseISO(eventTime);
  if (isToday(time))
    return `${labels.today} ${format(time, "HH:mm")}`;
  if (isYesterday(time))
    return `${labels.yesterday} ${format(time, "HH:mm")}`;
  return format(time, "dd.MM.yy, HH:mm");
};
const formatDigits = (value) => {
  return value.toString().padStart(2, "0");
};
const formatCounter = (counter, labels) => {
  if (!counter)
    return null;
  const { days, hours, isLate, minutes, seconds } = counter;
  if (isLate) {
    const formattedMinutes = `${minutes} ${labels.minutes}`;
    const formattedHours = `${hours} ${labels.hours}`;
    const formattedDays = `${days} ${labels.days}`;
    if (days === 0 && hours === 0) {
      return `-${formatDigits(minutes)}:${formatDigits(seconds)} min`;
    }
    if (days === 0 && hours > 0) {
      return `-${formattedHours} ${formattedMinutes}`;
    }
    if (days > 0) {
      return `-${formattedDays} ${formattedHours}`;
    }
  }
  return `${formatDigits(Math.abs(minutes))}:${formatDigits(Math.abs(seconds))} min`;
};
export {
  formatCounter,
  formatEventTime,
  getUnsuccessfullCallbackTime
};
